import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoginActivityService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private componentName = 'user';
    private _url = (this.serverUrl + '/api/v{version}/{componentName}')
        .replace('{version}', this.version)
        .replace('{componentName}', this.componentName);

    constructor(private http: HttpClient) {}

    getLoginActivity(
        fromDate: string,
        toDate: string,
        timeZoneVariance: string = '-5',
        filterByClient: boolean = true
    ): Observable<LoginActivity[]> {
        const params = new HttpParams()
            .set('fromDate', fromDate)
            .set('toDate', toDate)
            .set('timeZoneVariance', timeZoneVariance)
            .set('filterByClient', filterByClient.toString());

        return this.http.get<LoginActivity[]>(this._url + '/GetLoginActivity', {
            params: params,
        });
    }
}

export interface LoginActivity {
    friendlyTime?: string;
    clientShortName: string;
    lastName: string;
    firstName: string;
    jobTitle: string;
    lastLoginDate: Date;
    loginCount: number;
    lastLoginDateNoTime: Date;
    fullName: string;
    loginEmail: string;
}
